<template>
  <div>
    <v-dialog width="800px" v-model="show" persistent>
      <v-card>
        <v-app-bar dark color="primary">
          <v-toolbar-title>{{'Properties'}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <div>
            <v-btn
              icon
              @click="closeDialog"
              class="ml-auto"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </v-app-bar>
        <v-tabs v-model="tab" grow>
          <v-tab key="location">Location</v-tab>
          <v-tab key="notes">Notes</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item key="location">
            <v-container>
              <v-col class="ma-0 pa-0">
                <h3 style="color: #4285F4">Street Location</h3>
                <v-row align="center">
                  <v-col cols="12">
                    <v-text-field
                      v-model="delivery.street1"
                      label="Street adresse"
                      :readonly="true"
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="5">
                    <v-text-field
                      v-model="delivery.suburb"
                      label="Suburb"
                      :readonly="true"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="delivery.postcode"
                      label="Postcode"
                      :readonly="true"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="delivery.state"
                      label="State"
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="ma-0 pa-0">
                <v-row class="ma-0 pa-0">
                  <h3 style="color: #4285F4">Pin detail</h3>
                  <v-spacer></v-spacer>
                  <v-btn text small @click="enableEditing = !enableEditing" :color="enableEditing?'primary':''">Set</v-btn>
                </v-row>
                <v-row align="center">
                  <v-col cols="6">
                    <v-text-field
                      v-model="pin.lat"
                      label="Latitude"
                      type="number"
                      :readonly="!enableEditing"
                      @input="updateMarkerPos"
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="pin.lng"
                      label="Longitude"
                      type="number"
                      :readonly="!enableEditing"
                      @input="updateMarkerPos"
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row justify="center">
                  <v-col cols="12">
                    <GmapMap
                      :center="{lat: parseFloat(this.pin.lat), lng: parseFloat(this.pin.lng)}"
                      :zoom="17"
                      map-type-id="terrain"
                      style="height: 40vh; width: 100%"
                    >
                      <GmapMarker
                        ref="marker"
                        :draggable="enableEditing" @drag="updateCoordinates"
                        :position="{lat: parseFloat(this.pin.lat), lng: parseFloat(this.pin.lng)}"
                        :clickable="true"
                        @click="center={lat: parseFloat(this.pin.lat), lng: parseFloat(this.pin.lng)}"
                      />
                    </GmapMap>
                  </v-col>
                </v-row>

              </v-col>
              <v-col cols="12">
                <v-btn
                  @click=""
                  block primary
                  color="#1357a4"
                  style="color:#FFFFFF"
                >
                  Save changes
                </v-btn>
              </v-col>
            </v-container>
          </v-tab-item>
          <v-tab-item key="notes">
            <v-container>
              <h3 style="color: #4285F4">Notes</h3>
              <v-col>
                <v-textarea
                  clear-icon="cancel"
                  label="Internal notes"
                  :value="internalNote"
                ></v-textarea>
              </v-col>
              <v-col>
                <v-textarea
                  clear-icon="cancel"
                  label="Pop up notes"
                  :value="popupNote"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-btn
                  @click=""
                  block primary
                  color="#1357a4"
                  style="color:#FFFFFF"
                >
                  Save changes
                </v-btn>
              </v-col>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: "PropertiesDialog",
    components: {
    },
    props: {
      delivery: Object,
      showDialog: Boolean,
    },
    data() {
      return {
        tab: null,
        enableEditing: false,
        zoom: 15,
        pin: {
          lat: this.delivery.site_latitude,
          lng: this.delivery.site_longitude
        },
        internalNote: null,
        popupNote: null
      }
    },
    methods: {
      closeDialog(){
        this.show = false;
      },
      updateCoordinates(location) {
        this.pin = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng(),
        };
      },
      updateMarkerPos(){
        // const lat = parseFloat(this.pin.lat);
        // const lng = parseFloat(this.pin.lng);
        // var latlng = new google.maps.LatLng();
        // console.log(latlng, lat, lng);
        // this.$refs.marker.$markerObject.setPosition(latlng);
      }
    },
    mounted() {
      console.log(this.$refs)
    },
    computed: {
      show: {
        get() {
          return this.showDialog;
        },
        set(value) {
          if (!value) this.$emit('close');
        }
      },
    },
  }
</script>

<style src="../../../../../node_modules/leaflet/dist/leaflet.css"></style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/PropertiesDialog.vue